import { FILTER_TYPES } from 'common/constants/filters';
import { SECTIONS_KEYS } from 'modals/EditCustomPmMetricsModal/EditCustomPmMetricsModal.service';
import { IssueStateTooltip } from './Tooltips/labels-list/IssueStateTooltip';
import PdtTooltip from './Tooltips/labels-list/PdtTooltip';
import { TeamToolTip } from './Tooltips/labels-list/TeamTooltip';
import _ from 'lodash';
import { TeamLabel } from './LabelsList';
import { PM_PROVIDERS } from 'common/constants/constants';

export const getIsEmptyFilters = entityFilters =>
  _.size(entityFilters) === 0 ||
  _.every(entityFilters, values => values?.length === 0);

export const shouldShowToolTip = ({ key, allStatuses, title }) => {
  const duplicateValues =
    allStatuses?.filter(item => item.name === title) || [];
  const supportedFiltersTooltip = [
    FILTER_TYPES.ORGANIZATION_TEAMS,
    FILTER_TYPES.ORGANIZATION_PDT,
    duplicateValues.length > 1 && SECTIONS_KEYS[PM_PROVIDERS.JIRA].ISSUE_STATE,
    duplicateValues.length > 1 &&
      SECTIONS_KEYS[PM_PROVIDERS.AZURE_BOARDS].ISSUE_STATE
  ].filter(Boolean);
  return supportedFiltersTooltip.includes(key);
};

export const chooseTooltip = ({
  key,
  id,
  allStatuses,
  title,
  projectsByTeamId = {},
  teamsByIds = {}
}) => {
  const duplicateValues = allStatuses?.filter(item => item.name === title);
  const mapKeyToTooltip = {
    [SECTIONS_KEYS[PM_PROVIDERS.JIRA].ISSUE_STATE]: (
      <IssueStateTooltip state={title} count={duplicateValues?.length} />
    ),
    [SECTIONS_KEYS[PM_PROVIDERS.AZURE_BOARDS].ISSUE_STATE]: (
      <IssueStateTooltip state={title} count={duplicateValues?.length} />
    ),
    [FILTER_TYPES.ORGANIZATION_TEAMS]: (
      <TeamToolTip
        team={teamsByIds?.[id]}
        filters={_.get(projectsByTeamId[id], 'filter')}
      />
    ),
    [FILTER_TYPES.ORGANIZATION_PDT]: <PdtTooltip id={id} name={title} />
  };
  const Tooltip = mapKeyToTooltip[key];
  return Tooltip;
};

export const chooseLabel = ({
  id,
  key,
  title,
  color,
  projectsByTeamId,
  teamsByIds
}) => {
  return key === FILTER_TYPES.ORGANIZATION_TEAMS ? (
    <TeamLabel
      data-testid={`team-label-${title}`}
      title={title}
      color={color || _.get(teamsByIds?.[id], 'color')}
      isEmptyFilters={getIsEmptyFilters(projectsByTeamId?.[id]?.filter)}
    />
  ) : (
    title
  );
};
